var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"width":"120","src":require('@/assets/images/' + _vm.logo),"alt":"shelter logo"}})])],1),_c('li',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }